import * as Sentry from '@sentry/react';
import { getCorrelationId } from '@hooks/useCorrelationId';
import sentryConfig, { isDeterministicUiE2eMode } from '../sentry.config';

if (!isDeterministicUiE2eMode) {
    // Initialize Sentry for error tracing
    Sentry.init(sentryConfig);
    // Ease debugging between frontend and backend by tagging all
    // Sentry events with the stored correlation_id
    Sentry.setTag('correlation_id', getCorrelationId());
}
